module.exports = __webpack_public_path__ + "img/Picture12.0fa81af5.jpg";